






























































































import Vue, { PropType } from 'vue';
import Term from '../../components/term.vue';
import { ValidationProvider } from 'vee-validate';
import PForm from '@/components/proff/PForm.vue';

export default Vue.extend({
  components: {
    Term,
    ValidationProvider,
  },
  props: {
    pErrors: {
      type: Array as PropType<string[]>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    isAlertPageLeaving: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formData: {
        password: null,
        password_confirmation: null,
        checkPolicy: false,
      },
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
    onChangeCheckPolicy(val: boolean) {
      this.formData.checkPolicy = val;
    },
    resetValidator() {
      const pForm = this.$refs.PForm as InstanceType<typeof PForm>;
      if (pForm) pForm.resetValidator();
    },
  },
});
